export { default } from './IntroCopy';